import React, { useState } from "react";
import Layout from "../components/Layout";
import { useReduxSelector } from "../redux/hooks";
import { useNavigate } from "react-router-dom";
import axios from 'axios';
import { toast } from 'sonner';
import { ModalComponent } from "../components/Modal";

const Settings = () => {
  const { user, isSignedIn } = useReduxSelector((state) => state.user);
  const pathname = window.location.pathname;
  const navigate = useNavigate();
  const [isDeleting, setIsDeleting] = useState(false);
  const [openDeleteModal, setOpenDeleteModal] = useState(false);

  const handleDeleteAccount = async () => {
    try {
      setIsDeleting(true);
      const response = await axios.delete(
        `https://healthpro-api.thetrusthospital.com/users/v1/corporate/health/facilities/1/users/${user?.user?.patient?.patientId}`,
        {
          headers: { Authorization: `Bearer ${user?.access_token}` }
        }
      );

      if (response.status === 200) {
        toast.success('Account deleted successfully');
        navigate('/signin');
      }
    } catch (error: any) {
      toast.error(error.response?.data?.message || 'Failed to delete account');
    } finally {
      setIsDeleting(false);
      setOpenDeleteModal(false);
    }
  };

  return (
    <>
      {isSignedIn ? (
        <Layout pathname={pathname}>
          <div className="p-6">
            <h1 className="text-2xl font-bold text-primary-100 mb-6">Account Settings</h1>
            
            <div className="bg-white rounded-lg shadow-md p-6">
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                <div>
                  <h2 className="text-lg font-semibold mb-4">Personal Information</h2>
                  <div className="space-y-4">
                    <div>
                      <label className="text-sm text-gray-600">First Name</label>
                      <p className="font-medium">{user?.user?.firstName || 'N/A'}</p>
                    </div>
                    <div>
                      <label className="text-sm text-gray-600">Last Name</label>
                      <p className="font-medium">{user?.user?.lastName || 'N/A'}</p>
                    </div>
                    <div>
                      <label className="text-sm text-gray-600">Username</label>
                      <p className="font-medium">{user?.user?.username || 'N/A'}</p>
                    </div>
                    <div>
                      <label className="text-sm text-gray-600">Other Name</label>
                      <p className="font-medium">{user?.user?.otherName || 'N/A'}</p>
                    </div>
                  </div>
                </div>
                
                <div>
                  <h2 className="text-lg font-semibold mb-4">Medical Information</h2>
                  <div className="space-y-4">
                    <div>
                      <label className="text-sm text-gray-600">Patient ID</label>
                      <p className="font-medium">{user?.user?.patient?.patientId || 'N/A'}</p>
                    </div>
                    <div>
                      <label className="text-sm text-gray-600">Date of Birth</label>
                      <p className="font-medium">{user?.user?.patient?.dateOfBirth || 'N/A'}</p>
                    </div>
                    <div>
                      <label className="text-sm text-gray-600">Health Facility</label>
                      <p className="font-medium">{user?.corporateHealthFacility?.name || 'N/A'}</p>
                    </div>
                    <div>
                      <label className="text-sm text-gray-600">Role</label>
                      <p className="font-medium">{user?.user?.role || 'N/A'}</p>
                    </div>
                  </div>
                </div>
              </div>

              <div className="mt-8 pt-6 border-t">
                <h2 className="text-lg font-semibold mb-4 text-red-600">Danger Zone</h2>
                <div className="flex items-center justify-between p-4 bg-red-50 rounded-lg">
                  <div>
                    <h3 className="font-medium text-red-700">Delete Account</h3>
                    <p className="text-sm text-red-600">Once you delete your account, there is no going back. Please be certain.</p>
                  </div>
                  <button
                    onClick={() => setOpenDeleteModal(true)}
                    className="px-4 py-2 bg-red-600 text-white rounded-md hover:bg-red-700 transition-colors duration-200"
                  >
                    Delete Account
                  </button>
                </div>
              </div>
            </div>
          </div>

          <ModalComponent open={openDeleteModal} handleClose={() => setOpenDeleteModal(false)}>
            <h3 className="text-xl font-medium">
              Delete account
            </h3>
            <p className="text-xs mt-2">
              This action cannot be undone. All your data will be permanently deleted.
            </p>
            <div className="flex justify-between mt-12 space-x-3">
              <button
                className="py-2 border border-red-500 hover:bg-red-50 rounded-md w-full text-red-600 disabled:opacity-50"
                onClick={handleDeleteAccount}
                disabled={isDeleting}
              >
                {isDeleting ? 'Deleting...' : 'Yes'}
              </button>
              <button
                className="py-2 bg-primary-100 rounded-md w-full text-white hover:opacity-95"
                onClick={() => setOpenDeleteModal(false)}
              >
                Cancel
              </button>
            </div>
          </ModalComponent>
        </Layout>
      ) : (
        <div className="flex flex-col justify-center items-center m-auto w-full h-screen">
          <p>Please sign in to continue</p>
          <button
            className="bg-primary-300 text-white py-3 px-8 mt-4 text-sm rounded-3xl shadow-2xl"
            onClick={() => navigate("/signin")}
          >
            Sign In
          </button>
        </div>
      )}
    </>
  );
};

export default Settings; 